import { db } from "../firebase/config";

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";

import { useState, useEffect } from "react";

export const useAuthentication = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);

  // deal with memory leak
  const [cancelled, setCancelled] = useState(false);

  const auth = getAuth();

  if (db) {
    
  }

  function checkIfIsCancelled() {
    if (cancelled) {
      return;
    }
  }

  const createUser = async (data) => {
    checkIfIsCancelled();

    setLoading(true);

    try {
      const { user } = await createUserWithEmailAndPassword(
        auth,
        data.username,
        data.password
      );

      await updateProfile(user, {
        displayName: data.displayName,
      });

      setLoading(false);
      return user;
    } catch (error) {
      // console.log(error.message);
      // console.log(typeof error.message);

      let systemErrorMessage;

      if (error.message.includes("Password")) {
        systemErrorMessage = "A senha precisa conter pelo menos 6 caracteres.";
      } else if (error.message.includes("email-already")) {
        systemErrorMessage = "E-mail já cadastrado.";
      } else {
        systemErrorMessage = "Ocorreu um erro, por favor tenta mais tarde.";
      }
      setLoading(false);
      setError(systemErrorMessage);
    }
  };

  const logout = () => {
    checkIfIsCancelled();
    
    localStorage.removeItem('userAPIData');
    signOut(auth);    
  };

  const login = async (data) => {
    checkIfIsCancelled();

    setLoading(true);
    setError(false);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, data.email, data.password);
      console.log('✅ Login Firebase realizado com sucesso');
      
      setLoading(false);
      return userCredential;
    } catch (error) {
      console.log(error.message);
      console.log(typeof error.message);
      console.log(error.message.includes("user-not"));

      let systemErrorMessage;

      if (error.message.includes("user-not-found")) {
        systemErrorMessage = "Usuário não encontrado.";
      } else if (error.message.includes("wrong-password")) {
        systemErrorMessage = "Senha incorreta.";
      } else if (error.message.includes("invalid-credential")) {
        systemErrorMessage = "Usuário ou senha incorretos";
      } else {
        systemErrorMessage = "Ocorreu um erro, por favor tentar novamente.";
      }

      console.log(systemErrorMessage);

      setLoading(false);
      setError(systemErrorMessage);
      throw error;
    }
  };

  const resetPassword = async (email) => {
    checkIfIsCancelled();

    setLoading(true);
    setError(false);

    try {
      await sendPasswordResetEmail(auth, email);
      setLoading(false);
      return true;
    } catch (error) {
      let systemErrorMessage;

      if (error.message.includes("user-not-found")) {
        systemErrorMessage = "Usuário não encontrado.";
      } else {
        systemErrorMessage = "Ocorreu um erro ao enviar o email de recuperação. Tente novamente mais tarde.";
      }

      setLoading(false);
      setError(systemErrorMessage);
      return false;
    }
  };

  useEffect(() => {
    return () => setCancelled(true);
  }, []);

  return {
    auth,
    createUser,
    error,
    logout,
    login,
    loading,
    resetPassword,
  };
};